<template>
  <div class="OAuthCreateAccountInteractiveFormContainer">
    <UserInteractiveFormContainer
      :product="product"
      :user="user"
      @userSubmitted="onUserSubmitted"
    />
  </div>
</template>
<script>
import UserInteractiveFormContainer from '@/containers/forms/user/interactive/UserInteractiveFormContainer.vue'
export default {
  name: 'OAuthCreateAccountInteractiveFormContainer',
  components: {
    UserInteractiveFormContainer,
  },
  props: {
    product: {
      type: String,
      default: '',
    },
  },
  emits: ['submit'],
  data() {
    return {
      user: {},
    }
  },
  methods: {
    onUserSubmitted() {
      this.$emit('submit')
    },
  },
}
</script>
<style lang="scss"></style>
